import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: "",
};

export const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
  },
});

export const { setCurrentPage } = sidebarSlice.actions;

export const selectCurrentPage = (state) => state.sidebar.currentPage;

export default sidebarSlice.reducer;
